import { HttpHeaders } from "@angular/common/http";
import { ItemStorageChargeTypeEnum } from "./Interfaces/ItemStorageChargeTypeEnum";
import { PickupDeliveryItemActionEnum } from "./Interfaces/PickupDeliveryItemActionEnum";
import { PropertyItemDocumentPurposeEnum } from "./Interfaces/PropertyItemDocumentPurposeEnum";
import { PickupDeliveryTypeEnum } from "./Interfaces/PickupDeliveryTypeEnum";
import { DateTime } from 'luxon';
export class PickupDeliveryItemActionEnumHelper {

	static getPublicChoices(): any[] {
		var col = PickupDeliveryItemActionEnum.getChoices()
			.filter(a => !PickupDeliveryItemActionEnumHelper.IsPublicEntryForbidden(a.Value))

		col.sort((a, b) => {
			return a.Text == b.Text ? 0 : (a.Text > b.Text ? 1 : -1);
		})
		return col;
	}

	static IsPublicEntryForbidden(val: number): boolean { //If this is updated, make sure to update the typescript version also
		switch (val) {
			case PickupDeliveryItemActionEnum.FeltPad:
				return true;
			default:
				return false;
		}
	}
}

export class PickupDeliveryTypeEnumHelper {


	static IsSingleStop(serviceType: number) : boolean{
		return PickupDeliveryTypeEnum.ServiceOnly == serviceType
			|| PickupDeliveryTypeEnum.WillCall == serviceType;
	}
}
export class ItemStorageChargeTypeEnumHelper {

	static getPublicChoices(includeSystemPriced: boolean): any[] {
		var col = ItemStorageChargeTypeEnum.getChoices()
			.filter(a => !ItemStorageChargeTypeEnumHelper.IsPublicEntryForbidden(a.Value))

		if (!includeSystemPriced) {
			col = col.filter(a => !ItemStorageChargeTypeEnumHelper.isSystemPriced(a.Value));
		}
		col.sort((a, b) => {
			return a.Text == b.Text ? 0 : (a.Text > b.Text ? 1 : -1);
		})
		return col;
	}

	static IsPublicEntryForbidden(val: number) : boolean { //If this is updated, make sure to update the typescript version also
		switch (val) {
			case ItemStorageChargeTypeEnum.UnstackableFee:
			case ItemStorageChargeTypeEnum.WillCallFee:
				return true;
			default:
				return false;
		}
	}

	static isSystemPriced(obj: number): boolean {
		if (!obj) {
			return true;
		}
		switch (obj) {
			//If this is updated, make sure to update the typescript version also
			case ItemStorageChargeTypeEnum.PullForDelivery:
			case ItemStorageChargeTypeEnum.OversizeFee:
			case ItemStorageChargeTypeEnum.WarehouseAssemblyFee:
			case ItemStorageChargeTypeEnum.UnstackableFee:
			case ItemStorageChargeTypeEnum.ReceivingFee:
			case ItemStorageChargeTypeEnum.MinimumReceivingFee:
			case ItemStorageChargeTypeEnum.InspectionFee:
				return true;
			default:
				return false;
		}
	}
}

export class PropertyItemDocumentPurposeEnumHelper {

	static getPropertyItemImages(includeNothing: boolean): any[] {
		var col = PropertyItemDocumentPurposeEnum.getChoices()
			.filter(a => PropertyItemDocumentPurposeEnumHelper.IsPropertyItem(a.Value));

		if (!includeNothing) {
			col = col.filter(a => a.Value != PropertyItemDocumentPurposeEnum.Nothing);
		}

		col.sort((a, b) => {
			if (a.Value == PropertyItemDocumentPurposeEnum.Nothing || b.Value == PropertyItemDocumentPurposeEnum.Nothing) {
				return a.Value == b.Value ? 0 : (a.Value > b.Value ? 1 : -1);
			}
			return a.Text == b.Text ? 0 : (a.Text > b.Text ? 1 : -1);
		});
		return col;
	}

	static getPickupDeliveryImages(): any[] {
		var col = PropertyItemDocumentPurposeEnum.getChoices()
			.filter(a => PropertyItemDocumentPurposeEnumHelper.IsPickupDeliveryItem(a.Value))
			.filter(a => a.Value != PropertyItemDocumentPurposeEnum.Nothing);

		col.sort((a, b) => {
			return a.Text == b.Text ? 0 : (a.Text > b.Text ? 1 : -1);
		});
		return col;
	}

	static IsPropertyItem(val: number): boolean { 
		return val < PropertyItemDocumentPurposeEnum.SignatureImage;
	}

	static IsPickupDeliveryItem(val: number): boolean {
		return val >= PropertyItemDocumentPurposeEnum.SignatureImage;
	}
}

export class PersonRoleEnum {
	static SUPERADMIN = "SUPERADMIN";
	static DEVELOPER = "DEVELOPER";
	static SYSTEMROLEEMPLOYEE = "EMPLOYEE";
	static SYSTEMROLECUSTOMERACCOUNT = "CUSTOMERACCOUNT";
	static SYSTEMROLEWAREHOUSECUSTOMERACCOUNT = "WAREHOUSECUSTOMERACCOUNT";

	static SYSTEMROLECUSTOMERMASTERPERSONACTIVE = "CUSTOMERMASTERPERSONACTIVE";
	static SYSTEMROLEMASTERCUSTOMERACCOUNT = "MASTERCUSTOMERACCOUNT";

	static ADMIN = "ADMIN";
	static DRIVER = "DRIVER";
	static DISPATCH = "DISPATCH";
	static TREASURY = "TREASURY";
	static WAREHOUSE = "WAREHOUSE";

	static SUPPORTPERSON = "SUPPORTPERSON";
}

export interface BlobResponse {
	blob: Blob,
	fileName: string,
	error: string
}

export interface ContentAndStatus<T> {
	content: T,
	status: number,
	headers: HttpHeaders
}

export class TypeMessageEnumLimits {
	static AllowCustomTemplateLimit: number = 10000;
	static AllowAccountToCustomizeTemplateLimit: number = 5000;
}

export class BaseFilter {
	type: string = '';
	customer: string = '';
	include: boolean = false;

	isStringMatch(haystack: string, needle: string) {
		if (haystack && needle) {
			return haystack.toLowerCase().indexOf(needle.toLowerCase()) >= 0;
		}
		return false;
	}
}

export class PropertyFilter extends BaseFilter {
	description: string = '';
	sidemark: string = '';
	needsInspection?: boolean = null;
	needsRepair?: boolean = null;
	dateStart: Date = null;
	dateFinish: Date = null;
	includeDelivered?: boolean = false;

	isPUDDescriptionMatch(item: TooBig4Car.Logic.PickupDeliveryItem): boolean {
		if (item) {
			return this.isStringMatch(item.Description, this.description)
				|| this.isStringMatch(item.Sidemark, this.sidemark)
				|| this.isStringMatch(item.DestinationRoom, this.description)
				|| this.isStringMatch(item.Manufacturer, this.description)
				|| this.isStringMatch(item.AccountNumber, this.description)
				|| ((item.PropNumber ?? 0) > 0 && this.isStringMatch(item.PropNumber.toString(), this.description))
				;
		}
		return false;
	}

	isDescriptionMatch(item: TooBig4Car.Logic.PropertyItem): boolean {
		if (item) {
			return this.isStringMatch(item.Description, this.description)
				|| this.isStringMatch(item.Sidemark, this.sidemark)
				|| this.isStringMatch(item.DestinationRoom, this.description)
				|| this.isStringMatch(item.Manufacturer, this.description)
				|| this.isStringMatch(item.AccountNumber, this.description)
				|| ((item.PropNumber ?? 0) > 0 && this.isStringMatch(item.PropNumber.toString(), this.description))
				;
		}
		return false;
	}

	filterPUDItems(items: TooBig4Car.Logic.PickupDeliveryItem[]): TooBig4Car.Logic.PickupDeliveryItem[] {
		var col: TooBig4Car.Logic.PickupDeliveryItem[] = [];
		if (items) {
			items.forEach(item => {
				if (item) {
					var isOk = true;
					if (this) {
						if (this.type) {
							isOk = isOk && this.isStringMatch(item.TypeName, this.type);
						}
						if (this.description || this.sidemark) {
							isOk = isOk && this.isPUDDescriptionMatch(item);
						}
					}
					if (isOk) {
						col.push(item);
						return;
					}
				}
			});
		}
		return col;
	}

	filterItems(items: TooBig4Car.Logic.PropertyItem[]): TooBig4Car.Logic.PropertyItem[] {
		var col: TooBig4Car.Logic.PropertyItem[] = [];
		if (items) {
			items.forEach(item => {
				if (item) {
					var isOk = true;
					if (this) {
						if (item.DateArrivedLocal) {
							var arrivedLocal = DateTime.fromJSDate(new Date(item.DateArrivedLocal.toString().replace('Z', ''))).startOf('day');
							if (this.dateStart) {
								isOk = isOk && arrivedLocal >= DateTime.fromJSDate(new Date(this.dateStart)).startOf('day');
							}
							if (this.dateFinish) {
								isOk = isOk && arrivedLocal <= DateTime.fromJSDate(new Date(this.dateFinish)).startOf('day');
							}
						}
						if (this.type) {
							isOk = isOk && this.isStringMatch(item.TypeName, this.type);
						}
						if (this.description || this.sidemark) {
							isOk = isOk && this.isDescriptionMatch(item);
						}
						if (this.customer) {
							isOk = isOk && this.isStringMatch(item.CustomerAccountName, this.customer);
						}
						if (null != this.needsInspection) {
							isOk = isOk && item.NeedsInspection == this.needsInspection;
						}
						if (null != this.needsRepair) {
							isOk = isOk && item.NeedsRepair == this.needsRepair;
						}
					}
					if (isOk) {
						col.push(item);
						return;
					}
				}
			});
		}
		return col;
	}
}
